import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import InputTextField from "../../../../components/input/inputTextField";
import InputDatePicker from "../../../../components/input/inputDatePicker";
import moment from "moment";
import { useParams } from "react-router-dom";
import UploadFile from "../../../../components/upload/UploadFile";
import { useTranslation } from "react-i18next";
import CheckBoxCustom from "../../../../components/checkbox/CheckBoxCustom";

export default function MeetingRoomForm(props: any) {
  const { t } = useTranslation();

  const { formMeetingRoom, setFormMeetingRoom } = props;
  const { id } = useParams();

  console.log(formMeetingRoom);
  return (
    <section className="w-full mt-10">
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputDatePicker
            heading={t("วันที่เริ่มต้น")}
            placeholder={t("วันที่เริ่มต้น")}
            value={formMeetingRoom?.meeting_room_start_date || undefined}
            onChange={(e: any) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_start_date: moment(e).format("yyyy-MM-DD"),
              });
            }}
            helperText={""}
            disabled={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputDatePicker
            heading={t("วันที่สิ้นสุด")}
            placeholder={t("วันที่สิ้นสุด")}
            value={formMeetingRoom?.meeting_room_end_date || undefined}
            onChange={(e: any) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_end_date: moment(e).format("yyyy-MM-DD"),
              });
            }}
            helperText={""}
            disabled={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t("เวลาเริ่มต้น")}
            placeholder={t("เวลาเริ่มต้น")}
            value={formMeetingRoom?.meeting_room_start_time}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              console.log(e.target.value);
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_start_time: e.target.value,
              });
            }}
            helperText={""}
            type="time"
            disabled={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t("เวลาสิ้นสุด")}
            placeholder={t("เวลาสิ้นสุด")}
            value={formMeetingRoom?.meeting_room_end_time}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_end_time: e.target.value,
              });
            }}
            helperText={""}
            type="time"
            disabled={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={9}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t("ชื่อเรื่อง")}
            placeholder={t("ชื่อเรื่อง")}
            value={formMeetingRoom?.meeting_room_name}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_name: e.target.value,
              });
            }}
            helperText={""}
            disabled={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          sx={{
            alignSelf: "end",
          }}
        >
          <CheckBoxCustom label={t("สร้างปฎิทินกิจกรรม")} checked={formMeetingRoom?.is_content}
            setChecked={(check) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                is_content: check,
              });
            }} />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t("รายละเอียด")}
            placeholder={t("รายละเอียด")}
            value={formMeetingRoom?.meeting_room_desc}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_desc: e.target.value,
              });
            }}
            helperText={""}
            disabled={false}
            row={3}
            maxRows={5}
            disablePaddingMultiline
            multiline
            inputHeight={"auto"}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <UploadFile
            heading={t("ไฟล์แนบ")}
            fileAttachmentId={formMeetingRoom?.file?.file_name ?? ""}
            fileAttachmentName={formMeetingRoom?.file?.file_name ?? ""}
            noClick={false}
            onDeleteFile={() => { }}
            onDrop={(file) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                file: file
              });
            }}
            file={formMeetingRoom?.file ? formMeetingRoom?.file : ""}
            formatText={t("FILE_UPLOAD.FILE_SIZE")}
            disableDeleteFileId={true}
            onDeleteFileId={() => { }}
            hiddenDownloadFile={false}
          />
        </Grid>
      </Grid>
    </section>
  );
}
